<template>
  <div>
    <Title :pages="[{ icon: 'circle', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :modal_title="modal_title"
        :button_name="'Crear ' + modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{ itemsPerPage: 15 }"
          @pagination="updatePagination"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.tipo_comprobante ? props.item.tipo_comprobante.name : "-" }}</td>
              <td class="text-center px-0" style="min-width: 100px">
                <v-tooltip bottom v-if="!props.item.internal">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access && !props.item.internal" v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)">edit</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewItem(props.item)">remove_red_eye</v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!props.item.internal">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access && !props.item.internal" v-on="on" small color="red" class="mr-2" @click="deleteItem(props.item)">delete</v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Búsqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { tesoreriaClaseComprobanteService } from "@/libs/ws/tesoreriaClaseComprobanteService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import Modal from "./Modal.vue";
import RolMixin from "@/mixins/RolMixin.vue";

export default {
  components: { Title, Modal, DialogDelete },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      parent: this,
      service: tesoreriaClaseComprobanteService,
      page_title: "Tipo de comprobantes",
      modal_title: "Tipo de comprobante",
      mainItem: {
        id: 0,
        code: "",
        name: "",
        tipo_comprobante: null,
      },
      defaultItem: null,
      headers: [
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Nombre", align: "left", sortable: true, value: "name" },
        { text: "Tipo", align: "left", sortable: true, value: "tipo_comprobante.name" },
        { text: "Acción", align: "center", value: "" },
      ],
      list: [],
      dialog_delete: false,
    };
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
  },
  methods: {
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.loadList(this.service);
    },
    getFilterParams() {
      return {};
    },
  },
};
</script>
